// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z2c2","select":"styles_select__HZS14"};